import validate from "/root/workspace/whale-homepage_AeEf/node_modules/.pnpm/nuxt@3.0.0_@types+node@24.0.3_eslint@8.57.1_ioredis@5.6.1_less@4.3.0_optionator@0.9.4_r_2bf2842c81d12fc4afc6493420e276ff/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import encode_45uri_45global from "/root/workspace/whale-homepage_AeEf/middleware/encodeURI.global.ts";
import inherit_45url_45query_45global from "/root/workspace/whale-homepage_AeEf/middleware/inheritUrlQuery.global.ts";
import log_45global from "/root/workspace/whale-homepage_AeEf/middleware/log.global.ts";
export const globalMiddleware = [
  validate,
  encode_45uri_45global,
  inherit_45url_45query_45global,
  log_45global
]
export const namedMiddleware = {}